import React from 'react';

export const PRIORITY_CLASS = {
  상: 'insight-panel__item--high',
  중: 'insight-panel__item--mid',
  하: 'insight-panel__item--low',
  P0: 'insight-panel__item--high',
  P1: 'insight-panel__item--mid',
  P2: 'insight-panel__item--low',
};

export const PRIORITY_LABEL = {
  상: '중요도 상',
  중: '중요도 중',
  하: '중요도 하',
  P0: '중요도 상',
  P1: '중요도 중',
  P2: '중요도 하',
};

export const compactEvidenceText = (value, limit = 360) => {
  const text = String(value || '').replace(/\s+/g, ' ').trim();
  return text.length > limit ? `${text.slice(0, limit)}…` : text;
};

export const cleanInternalCommentPrefix = (value) => {
  const text = String(value || '').trim();
  const match = text.match(/^\s*screen\s*index\s*([^:\n]{0,180})\s*:\s*/i);
  if (!match) return text;
  const metadata = String(match[1] || '').trim();
  return /^(?:\d+\b|\([^)\n]{1,80}\)|\/)/.test(metadata)
    ? (text.slice(match[0].length).trim() || text)
    : text;
};

export function InsightReportEvidence({ items, sourceLabel, cleanText = false }) {
  if (!items?.length) return null;

  return (
    <div className="insight-report-item__comments">
      <span className="insight-report-item__voc-label">원본 보이스</span>
      {items.map((item) => (
        <blockquote key={item.id}>
          <header>
            <strong>{item.personaName || item.persona_name}</strong>
            <span>{sourceLabel}</span>
          </header>
          {item.question ? <small>Q. {compactEvidenceText(item.question, 120)}</small> : null}
          <p>{compactEvidenceText(cleanText ? cleanInternalCommentPrefix(item.text) : item.text)}</p>
        </blockquote>
      ))}
    </div>
  );
}

export function InsightReportActionItem({ item, children }) {
  return (
    <article
      className={`insight-report-item ${PRIORITY_CLASS[item.priority] || ''}`}
    >
      <div className="insight-report-item__head">
        <span>{PRIORITY_LABEL[item.priority] || item.priority}</span>
        <h4>{item.title}</h4>
      </div>
      <div className="insight-report-item__body">
        <p><strong>문제</strong>{item.issue}</p>
        <p><strong>개선 방향</strong>{item.solution}</p>
      </div>
      {children}
    </article>
  );
}
